import { runoutTimes } from '@constants/orderDispatch'
import moment from 'moment'
import React, { useState, forwardRef, useEffect, useImperativeHandle } from 'react'
import { filterByRunoutTime } from '../Runout/runoutFilter'
import { TimeSpanFilter } from '../TimeSpan/TimeSpan'

export default forwardRef((props, ref) => {
  const [selectedOptions, setSelectedOptions] = useState('')
  const buttons = [
    { text: 'Fits Now', value: runoutTimes.NOW, className: 'mt-4 ml-3 mr-3' },
    { text: '12 Hours', value: runoutTimes.HALFDAY, className: 'mt-4 ml-3 mr-3' },
    { text: '24 Hours', value: runoutTimes.DAY, className: 'mt-3 ml-3 mr-3' },
    { text: '3 Days', value: runoutTimes.THREEDAYS, className: 'mt-3 ml-3 mr-3' },
  ]

  useImperativeHandle(ref, () => {
    return {
      doesFilterPass(params) {
        const now = moment()
        const retain = moment(params.data.dispatch_window_start)

        if (selectedOptions === 'now') {
          return retain.isSameOrBefore(now)
        }

        return filterByRunoutTime(params.data.dispatch_window_start, selectedOptions)
      },
      isFilterActive() {
        return !!selectedOptions
      },
    }
  })

  useEffect(() => {
    props.filterChangedCallback()
  }, [selectedOptions])

  const onClick = (value) => {
    if (selectedOptions && selectedOptions.includes(value)) {
      setSelectedOptions('')
    } else {
      setSelectedOptions(value)
    }
  }

  const onClear = () => {
    setSelectedOptions(null)
  }

  return (
    <TimeSpanFilter
      property='runoutTime'
      buttons={buttons}
      onClear={onClear}
      onClick={onClick}
      selectedOptions={selectedOptions}
    />
  )
})
